<ng-template #modalRealizarConsulta let-modal>
    <div class="modal-header d-flex justify-content-between align-items-center">
        <h2>Editar Consulta</h2>
        <button (click)="modal.close('close')" class="btn btn-xs btn-danger rounded-circle btn-icon">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body scroll-auto p-2">
        <div class="row">
            <div *ngFor="let consulta of listaConsultas" class="col-12 col-sm-6 col-md-4 col-lg-3 p-1 p-md-2">
                <app-checkbox size='md' [label]="consulta.nome" [(disabled)]="consulta.disabled"
                    [(checked)]="consulta.checked" (checkedChange)="checkedChange()"></app-checkbox>
            </div>
        </div>
    </div>

    <div class="modal-footer py-0 bg-light">
        <div class="row w-100">
            <div *ngIf="form.controls.veiculo" class="col-lg-auto col-lg-7 p-2">
                <div class="d-flex justify-content-between align-items-end flex-column flex-sm-row">
                    <div class="d-flex">
                        <app-input-radio size="md" [(model)]="tipoPesquisaVeiculo" (modelChange)="setControlVeiculo()" value="placa" label="Placa"
                            class="mr-4"></app-input-radio>
                        <app-input-radio size="md" [(model)]="tipoPesquisaVeiculo" (modelChange)="setControlVeiculo()" value="chassi" label="Chassi"
                            class="mr-4"></app-input-radio>
                        <app-input-radio size="md" [(model)]="tipoPesquisaVeiculo" (modelChange)="setControlVeiculo()" value="motor" label="Motor"
                            class="mr-4"></app-input-radio>
                    </div>
                    <div class="w-100 mt-2 mt-sm-0">
                        <label for="pesquisaVeiculo">
                            Digite
                            {{tipoPesquisaVeiculo=='placa' ? ' a Placa ' : tipoPesquisaVeiculo=='chassi' ? ' o Chassi ' :
                            ' o Motor '}} do veículo
                        </label>
                        <input *ngIf="tipoPesquisaVeiculo=='placa'" [textMask]="masks.placa" type="text"
                            [formControl]="form.controls.veiculo" class="form-control input-validate text-uppercase">
                        <input *ngIf="tipoPesquisaVeiculo=='chassi'" type="text" [formControl]="form.controls.veiculo"
                            class="form-control input-validate text-uppercase">
                        <input *ngIf="tipoPesquisaVeiculo=='motor'" type="text" [formControl]="form.controls.veiculo"
                            class="form-control input-validate text-uppercase">
                    </div>
                </div>
                <app-msg-erro [control]="form.controls.veiculo"></app-msg-erro>
            </div>

            <div *ngIf="form.controls.documento" [style.minWidth.px]="300" class="col-12 col-md-6 col-lg p-2">
                <label for="documento">
                    Digite o documento (CPF ou CNPJ)
                </label>
                <input [textMask]="masks.documento" type="text" [formControl]="form.controls.documento"
                    class="form-control input-validate">
                <app-msg-erro [control]="form.controls.documento"></app-msg-erro>
            </div>
            <div *ngIf="form.controls.cnh" [style.minWidth.px]="300" class="col-12 col-md-6 col-lg p-2">
                <label for="pesquisaVeiculo">
                    Digite o número da CNH
                </label>
                <input type="text" [formControl]="form.controls.cnh" class="form-control input-validate">
                <app-msg-erro [control]="form.controls.cnh"></app-msg-erro>
            </div>
            <div *ngIf="form.controls.crlv" [style.minWidth.px]="300" class="col-12 col-md-6 col-lg p-2">
                <label for="pesquisaVeiculo">
                    Digite o CRLV
                </label>
                <input type="text" [formControl]="form.controls.crlv" class="form-control input-validate">
                <app-msg-erro [control]="form.controls.crlv"></app-msg-erro>
            </div>

        </div>

    </div>
    <div class="modal-footer">
        <button (click)="modal.close('cancel')" class="btn btn-secondary mr-auto btn-lg px-sm-5">Cancelar</button>
        <button [disabled]="!totalConsultas" (click)="confirmar(modal)"  class="btn btn-success btn-lg px-sm-5">Confirmar</button>
    </div>

</ng-template>